import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";

const OptionSection = () => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("promotion_register.option.title")}
      rows={[
        {
          label: t("promotion_register.option.form.data_check.label"),
          children: (
            <Stack direction="column">
              <FormControlLabel
                control={<Checkbox />}
                label={t("promotion_register.option.form.data_check.yes")}
                sx={{ color: "text.secondary" }}
              />
              <FormControlLabel
                control={<Checkbox />}
                label={t("promotion_register.option.form.data_check.priority")}
                sx={{ color: "text.secondary", pl: 4 }}
              />
            </Stack>
          ),
        },
        {
          label: t("promotion_register.option.form.profile.label"),
          children: (
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              flexWrap="wrap"
            >
              <FormControlLabel
                control={<Checkbox />}
                label={t("promotion_register.option.form.profile.marriage")}
                sx={{ color: "text.secondary" }}
              />
              <FormControlLabel
                control={<Checkbox />}
                label={t("promotion_register.option.form.profile.occupation")}
                sx={{ color: "text.secondary" }}
              />
              <FormControlLabel
                control={<Checkbox />}
                label={t("promotion_register.option.form.profile.industry")}
                sx={{ color: "text.secondary" }}
              />
              <FormControlLabel
                control={<Checkbox />}
                label={t("promotion_register.option.form.profile.number_of_people")}
                sx={{ color: "text.secondary" }}
              />
              <FormControlLabel
                control={<Checkbox />}
                label={t(
                  "promotion_register.option.form.profile.number_of_children",
                )}
                sx={{ color: "text.secondary" }}
              />
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {t("promotion_register.option.form.profile.sub_note")}
              </Typography>
            </Stack>
          ),
        },
        {
          label: t("promotion_register.option.form.templating.label"),
          children: (
            <Stack
              direction="row"
              alignItems="center"
              spacing={4}
              flexWrap="wrap"
            >
              <FormControlLabel
                control={<Checkbox />}
                label={t("promotion_register.option.form.templating.yes")}
                sx={{ color: "text.secondary" }}
              />
              <FormControl size="small" sx={{ width: "50%" }}>
                <InputLabel id="publication-range-label">
                  {t(
                    "promotion_register.option.form.templating.publication_range.label",
                  )}
                </InputLabel>
                <Select
                  labelId="publication-range-label"
                  label={t(
                    "register.option.form.templating.publication_range.label",
                  )}
                >
                  <MenuItem value="public">
                    {t(
                      "register.option.form.templating.publication_range.public",
                    )}
                  </MenuItem>
                  <MenuItem value="private">
                    {t(
                      "register.option.form.templating.publication_range.private",
                    )}
                  </MenuItem>
                </Select>
              </FormControl>
            </Stack>
          ),
        },
      ]}
    />
  );
};

export default OptionSection;
